import React from "react";
import { Box } from "@mui/system";
import { Container, Typography } from "@mui/material";
import { mainHeading, subHeading } from "../styles/style";
import Layout from "../assets/Layout";

export default function TermsConditions() {
  return (
    <>
      <Layout>
        <Box sx={{ textAlign: "center", my: 10 }}>
          <Typography sx={subHeading}>Terms & Conditions</Typography>
          <Typography sx={mainHeading}>Terms & Conditions</Typography>
        </Box>

        <Container>
          <Box>
            <Typography className="textDetails">
              Please read the following terms and conditions before using our
              services. These terms and conditions apply to all users of our
              services and visitors to our website. In these terms, 'we,' 'us,'
              and "PPLACD" refers to the PPLACD website, and 'you' refers to
              candidates, coaches, and any individual using our services or
              website. We are a platform to make learning, recruiting, and job
              searching convenient and more effective. At PPLACD, we welcome all
              individuals who aspire to succeed in their careers. Though, before
              using the website, we advise everyone to read and accept the terms
              and conditions.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">
              Copyright Statement
            </Typography>
            <ol>
              <li className="textDetails">
                The content of this website is copyrighted materials exclusively
                owned by PPLACD. However, you may get the print of this content
                for non- commercial use.
              </li>
              <li className="textDetails">
                No permission is granted to anyone to use the content of this
                Site for commercial purpose or to modify it for any other
                purpose.
              </li>
            </ol>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">
              Limitation on Use
            </Typography>
            <Typography className="textDetails">
              By registering or using the services of PPLACD, you affirm that
              you will use the data and services as a candidate, company, or
              coach to learn, find a job, recruit professionals, teach, and
              train.
            </Typography>
            <Typography className="textDetails">
              Users are not permitted to use our website or the data provided by
              us for commercial purposes. Examples are,
            </Typography>
            <ol>
              <li className="textDetails">
                Reselling the course or coach session to another person at a
                higher price.
              </li>
              <li className="textDetails">
                Sharing the candidate's profile for commercial purposes.
              </li>
              <li className="textDetails">
                The selling candidate's profile is present on PPLACD.
              </li>
              <li className="textDetails">
                Earning from our resume builder solution.
              </li>
              <li className="textDetails">
                The coaches and students shall not connect during personal hours
                without PPLACD acting as a mediator.
              </li>
            </ol>
            <Typography className="textDetails">
              We will take swift action against anyone found in violation of the
              above terms. Suppose PPLACD is presented with evidence that its
              services have been used contrary to this or any other part of
              these Terms of Use. In that case, PPLACD may, in its sole
              discretion, remove the materials, terminate the accounts of the
              involved users, and take this matter under legal review.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">
              Warranty and Limitation of Liability
            </Typography>
            <Typography className="textDetails">
              Some companies are posting the same job post to multiple
              mediums/channels. Therefore, we don't take the guarantee of
              providing unique job opportunities.
            </Typography>
            <Typography className="textDetails">
              Our resume builder has several designs and layouts which can't be
              discrete all the time. Thus, we guarantee smooth and effortless
              resume-building but not uncommon designs. As we offer professional
              and preferable resume layouts, other sites might have the same.
            </Typography>
            <Typography className="textDetails">
              The coaches and courses present on PPLACD are open to all
              aspirants with 1:1 training. If the candidate faces any issue
              while booking or receiving the coaching/session and applying for a
              job, they can directly communicate with the team.
            </Typography>
            <Typography className="textDetails">
              The users are limited from using our content and services for
              commercial use and from exploiting our team, coaches, companies,
              candidates, or any person/organization associated with PPLACD via
              our website.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">Charges</Typography>
            <Typography className="textDetails">
              We reserve the right to charge membership fees or subscriptions
              for our services
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">Severability</Typography>
            <Typography className="textDetails">
              If any of these terms becomes unenforceable as a whole or partly,
              the validity of other contract terms will remain unaffected.
            </Typography>
          </Box>
          <Box>
            <Typography className="subHeading1Details">Amendments</Typography>
            <Typography className="textDetails">
              We reserve the sole right to amend terms and conditions without
              serving notice to you. The latest version of terms and conditions
              will supersede previous versions.
            </Typography>
          </Box>
          <Box>
            <Typography className="subHeading1Details">Termination</Typography>
            <Typography className="textDetails">
              We reserve the sole right to terminate the whole or part of the
              service agreement at any time.
            </Typography>
          </Box>
          <Box>
            <Typography className="subHeading1Details">
              Entire Agreement
            </Typography>
            <Typography className="textDetails">
              Terms of Service made in the latest agreement between the user and
              PPLACD will supersede and terminate all the prior agreements.
            </Typography>
          </Box>
        </Container>
      </Layout>
    </>
  );
}
